import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import connectUI from 'redux-ui';
import { has } from 'lodash';
import Loading from 'components/Loading';
import MessageBox from 'components/MessageBox';
import RefigureHeader from 'refigureHeader';
import RefigureCard from 'refigureCard';
import StoreInformation from 'storeInformation';
import SpecialOptions from 'specialOptions';
import RefigureActions from 'refigureActions';
import Card from 'components/Card';
import { ThemeProvider } from 'react-css-themr';
import { requestSurfaceTypesList, requestRefigureForm, submitRefigureForm } from 'actionCreators';
import { getSurfaceTypeList } from '../../../reducers';
import RTCard from 'styles/card';
import RTInput from 'styles/input';
import RTDropdown from 'styles/dropdown';
import contentAreaStyles from 'styles/contentArea';

const theme = { RTInput, RTDropdown, RTCard };
const DEFAULT_STATE = {
  allFetched: false,
  refigureDetails: [{ id: 0 }],
  storeInfo: { associateName: '', associateEmail: '' },
  specialOptions: { rushRequest: false, commercialRefigure: false, rushRequestNote: '' },
  errors: {},
};

class Refigure extends Component {
  state = DEFAULT_STATE

  componentDidMount = () => {
    Promise.all([
      this.props.requestSurfaceTypesList(),
      this.props.requestRefigureForm(),
    ]).then(() => this.setState({ allFetched: true }));
  }

  addRefigureDetails = () => {
    const refigureDetails = this.state.refigureDetails;
    refigureDetails.push({ id: Math.round(Math.random() * 1000) + 1 });
    this.setState({ refigureDetails });
  }

  updateRefigureDetails = (index, details) => {
    const refigureDetails = this.state.refigureDetails;
    Object.assign(refigureDetails[index], details);
    this.setState({ refigureDetails });
  }

  deleteRefigureDetails = (index) => {
    const refigureDetails = this.state.refigureDetails;
    refigureDetails.splice(index, 1);
    this.setState({ refigureDetails });
  }

  updateStoreInformation = (storeInfo) => {
    this.setState({ storeInfo });
  }

  updateSpecialOptions = (specialOptions) => {
    this.setState({ specialOptions });
  }

  handleSubmit = () => {
    const valid = this.validate();
    if (!valid) return;
    const submitData = { ...this.state };
    delete submitData.allFetched;
    delete submitData.errors;
    this.props.submitRefigureForm(submitData);
  }

  validate = () => {
    const errors = {};
    Object.assign(errors, this.validateStoreInfo());
    Object.assign(errors, this.validateSpecialOptions());
    Object.assign(errors, this.validateRefigureDetails());
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  validateStoreInfo = () => {
    const { storeInfo } = this.state;
    const errors = {};
    if (!storeInfo.associateName) {
      errors.associateName = ["can't be blank"];
    }
    if (!storeInfo.associateEmail) {
      errors.associateEmail = ["can't be blank"];
    }
    return errors;
  }

  validateSpecialOptions = () => {
    const { specialOptions } = this.state;
    const errors = {};
    const { rushRequest, rushRequestNote } = specialOptions;
    const rushNoteRequired = rushRequest ? !rushRequestNote : false;
    if (rushNoteRequired) {
      errors.rushRequestNote = ["can't be blank"];
    }
    return errors;
  }

  validateRefigureDetails = () => {
    const { refigureDetails } = this.state;
    const errors = { refigureDetails: [] };
    let hasError = false;
    refigureDetails.forEach((detail) => {
      const hasSurfaceType = has(detail, 'surface_type');
      if (!hasSurfaceType || !detail.surface_type.id) {
        hasError = true;
        errors.refigureDetails.push({ surface_type: ["can't be blank"] });
      } else {
        errors.refigureDetails.push({});
      }
    });

    return hasError ? errors : {};
  }

  render() {
    const { surfaceTypes, refigureForm } = this.props;
    const { allFetched, refigureDetails, errors } = this.state;
    const serverError = Object.keys(refigureForm.errors).length > 0;
    return (allFetched ?
      <div>
        <RefigureHeader phaseDetails={refigureForm} />
        <div className={contentAreaStyles.contentAreaContainer}>
          <ThemeProvider theme={theme}>
            <Card>
              <StoreInformation
                updateStoreInformation={this.updateStoreInformation}
                errors={errors}
              />
              <SpecialOptions updateSpecialOptions={this.updateSpecialOptions} errors={errors} />
              {refigureDetails.map((detail, i) =>
                <RefigureCard
                  key={`details-${detail.id}`}
                  index={i}
                  surfaceTypes={surfaceTypes}
                  updateRefigureDetails={this.updateRefigureDetails}
                  deleteRefigureDetails={this.deleteRefigureDetails}
                  errors={errors}
                />)}
              <RefigureActions
                addRefigureDetails={this.addRefigureDetails}
                handleSubmit={this.handleSubmit}
              />
              {serverError &&
                <MessageBox error message="This action could not be completed." />}
            </Card>
          </ThemeProvider>
        </div>
      </div>
      : <Loading />
    );
  }
}

Refigure.propTypes = {
  surfaceTypes: PropTypes.array,
  requestSurfaceTypesList: PropTypes.func.isRequired,
  requestRefigureForm: PropTypes.func.isRequired,
  refigureForm: PropTypes.object,
  submitRefigureForm: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { refigureForm } = state;
  return {
    refigureForm,
    surfaceTypes: getSurfaceTypeList(state) || [],
  };
};

export default connectUI()(connect(
  mapStateToProps, {
    requestRefigureForm,
    requestSurfaceTypesList,
    submitRefigureForm,
  },
)(Refigure));



// WEBPACK FOOTER //
// ./client/app/screens/refigure/form/index.jsx